import { challenge } from "assets/svg/green";
import { lab, labProgram } from "assets/svg/blue";
import { resource, resourceCollection, resourceGroup } from "assets/svg/purple";
import { COMPONENT_TYPES } from "helpers/utils/constants";
import {
  AccessAlarm,
  AccessTime,
  CheckBox,
  Group,
  Inventory,
  Task,
} from "@mui/icons-material";
import { COLORS } from "helpers/utils/constants";

export const getChallengeReportDetails = (data, type) => {
  const mappings = {
    [COMPONENT_TYPES.CHALLENGE]: [
      {
        img: challenge,
        title: "Total Challenges",
        value: data?.totalChallenges,
      },
      {
        icon: AccessAlarm,
        title: "Active Challenges",
        value: data?.totalActiveChallenges ?? 0,
        color: COLORS.YELLOW,
      },
      {
        icon: CheckBox,
        title: "Completed Challenges",
        value: data?.totalCompletedChallenges ?? 0,
        color: COLORS.GREEN,
      },
      {
        icon: Inventory,
        title: "Closed Challenges",
        value: data?.totalCloseChallenges ?? 0,
        color: COLORS.DARK_GRAY,
      },
      {
        icon: Group,
        title: "Total Members",
        value: data?.totalActiveMembers ?? 0,
        iconColor: COLORS.GREEN,
      },
    ],
    [COMPONENT_TYPES.LAB]: [
      {
        img: lab,
        title: "Total Labs",
        value: data?.totalLabs || 0,
        color: COLORS.BLUE,
      },
      {
        img: labProgram,
        title: "Total Lab Programs",
        value: data?.totalLabPrograms ?? 0,
        color: COLORS.BLUE_OPAQUE,
      },
      {
        icon: Group,
        title: "Total Members",
        value: data?.totalActiveMembers ?? 0,
        color: COLORS.BLUE,
      },
    ],
    [COMPONENT_TYPES.RESOURCE]: [
      {
        img: resource,
        title: "Total Resource Modules",
        value: data?.totalResourceModule ?? 0,
        color: COLORS.PURPLE_OPAQUE,
      },
      {
        img: resourceCollection,
        title: "Total Resource Collections",
        value: data?.totalResourceCollection ?? 0,
        color: COLORS.PURPLE,
      },
      {
        img: resourceGroup,
        title: "Total Resource Groups",
        value: data?.totalResourceGroup ?? 0,
      },
      {
        icon: Group,
        title: "Total Viewers",
        value: data?.totalViewers ?? 0,
        color: COLORS.PURPLE,
      },
    ],
    [COMPONENT_TYPES.PROJECT]: [
      {
        icon: AccessTime,
        title: "Project in Progress",
        value: data?.totalInProgressProjects ?? 0,
        color: COLORS.YELLOW,
      },
      {
        icon: CheckBox,
        title: "Projects Submitted",
        value: data?.totalSubmittedProjects ?? 0,
        color: COLORS.GREEN,
      },
      {
        icon: Task,
        title: "Assessment Done",
        value: data?.totalAssessedProjects ?? 0,
        color: COLORS.RED,
      },
      {
        icon: Task,
        title: "Assessment Pending",
        value: data?.totalNonAssessedProjects ?? 0,
        color: COLORS.BLUE,
      },
    ],
  };
  return mappings[type] || [];
};

export const getChallengeReportDonutValues = (data, type) => {
  let filteredDetails = [];
  let totalValue = 0;
  let completedValue = 0;
  let title = "";

  if (type === COMPONENT_TYPES.CHALLENGE) {
    filteredDetails = [
      { value: data?.totalActiveChallenges ?? 0, color: COLORS.YELLOW },
      { value: data?.totalCompletedChallenges ?? 0, color: COLORS.GREEN },
      { value: data?.totalCloseChallenges ?? 0, color: COLORS.DARK_GRAY },
    ];
    totalValue = data?.totalChallenges ?? 0;
    completedValue = data?.totalActiveChallenges ?? 0;
    title = "Active";
  } else if (type === COMPONENT_TYPES.LAB) {
    filteredDetails = [
      { value: data?.totalLabs ?? 0, color: COLORS.BLUE },
      { value: data?.totalLabPrograms ?? 0, color: COLORS.BLUE_OPAQUE },
    ];
    totalValue = (data?.totalLabs ?? 0) + (data?.totalLabPrograms ?? 0);
    completedValue = data?.totalLabs ?? 0;
    title = "Labs";
  } else if (type === COMPONENT_TYPES.RESOURCE) {
    filteredDetails = [
      { value: data?.totalResourceModule ?? 0, color: COLORS.PURPLE },
      {
        value: data?.totalResourceCollection ?? 0,
        color: COLORS.PURPLE_OPAQUE,
      },
      { value: data?.totalResourceGroup ?? 0, color: COLORS.PURPLE_OPAQUE },
    ];
    totalValue =
      (data?.totalResourceModule ?? 0) +
      (data?.totalResourceCollection ?? 0) +
      (data?.totalResourceGroup ?? 0);
    completedValue = data?.totalResourceModule ?? 0;
    title = "Modules";
  } else if (type === COMPONENT_TYPES.PROJECT) {
    filteredDetails = [
      { value: data?.totalInProgressProjects ?? 0, color: COLORS.YELLOW },
      { value: data?.totalSubmittedProjects ?? 0, color: COLORS.GREEN },
      { value: data?.totalAssessedProjects, color: COLORS.RED },
      { value: data?.totalNonAssessedProjects, color: COLORS.BLUE },
    ];
    totalValue =
      (data?.totalInProgressProjects ?? 0) +
      (data?.totalSubmittedProjects ?? 0) +
      (data?.totalAssessedProjects ?? 0) +
      (data?.totalNonAssessedProjects ?? 0);
    completedValue = data?.totalSubmittedProjects ?? 0;
    title = "Submitted";
  }

  return { filteredDetails, totalValue, completedValue, title };
};


export const RECOMMENDATION_TABS = ["Challenges", "Labs", "Resources"];

export const statusTitleClass = {
  0: ["Not Started", "one"],
  1: ["In Progress", "two"],
  2: ["Completed", "three"],
};


export const STATUS_TYPES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
};

export const getTypeFilter = (component, value) => {
  switch (component) {
    case COMPONENT_TYPES.CHALLENGE:
    case COMPONENT_TYPES.LAB:
    case COMPONENT_TYPES.PROJECT:
      return {
        0: "my",
        1: "invites",
        2: "favourite",
      }[value];

    case COMPONENT_TYPES.RESOURCE:
      return {
        0: "my",
        1: "favourite",
      }[value];

    default:
      return null;
  }
};
